var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.$store.getters.currentRoomType
        ? [
            _vm.$store.getters.currentRoomType.DISPLAY?.ROOM_NON_SMOKING
              ? [
                  false !== _vm.isRoomTypeVariantExists("ROOM_SMOKING", true, 0)
                    ? _c(
                        "a",
                        {
                          attrs: {
                            title: "Click to See Smoking Room Options",
                            href: "#",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$store.commit("updateState", [
                                "isVariantDialogVisible",
                                true,
                              ])
                            },
                          },
                        },
                        [_vm._v("No")]
                      )
                    : [_vm._v("\n        No\n      ")],
                ]
              : _vm.$store.getters.currentRoomType.DISPLAY?.ROOM_SMOKING
              ? [
                  false !==
                  _vm.isRoomTypeVariantExists("ROOM_NON_SMOKING", true, 0)
                    ? _c(
                        "a",
                        {
                          attrs: {
                            title: "Click to See Smoking Room Options",
                            href: "#",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$store.commit("updateState", [
                                "isVariantDialogVisible",
                                true,
                              ])
                            },
                          },
                        },
                        [_vm._v("Yes")]
                      )
                    : _vm._e(),
                ]
              : [_vm._v("\n      Yes\n    ")],
          ]
        : _c(
            "a",
            {
              attrs: {
                "data-tooltip": "Click to See Smoking Room Options",
                href: "#",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$store.commit("updateState", [
                    "isVariantDialogVisible",
                    true,
                  ])
                },
              },
            },
            [_vm._v("No")]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }